









import { Component, Prop, Vue } from "vue-property-decorator";
import Approval from "@/interfaces/uniabc/Approval";
import DateUtils from "@/utils/DateUtils";

@Component
export default class ApprovalItem extends Vue {
  @Prop(Object) readonly approval!: Approval;

  private toShortDateStr(date: Date) {
    return DateUtils.getShortDateTimeString(new Date(date));
  }
}
